<template>
  <div class="Scale_classification">
    <div class="Scale_classification_nav">
      <div class="Scale_classification_nav_left">
        <scales @sendmsg="getmsg"></scales>
      </div>
      <div class="Scale_classification_nav_right">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" style="background-color: #fff;padding: 14px;">
          <el-form-item label="题目名称">
            <el-input v-model="questionName" placeholder="量表代号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="margin-left: 1%;margin-top: 14px;" @click="addfun()">新增</el-button>

        <el-table :data="tableData" style="width: 98%;margin-left: 1%;margin-top: 14px;">
          <el-table-column prop="questionName"  label="题目名称"></el-table-column>
          <el-table-column prop="questionID"    label="题目编号"></el-table-column>
          <el-table-column prop="answerID"      label="答案编号"></el-table-column>
          <el-table-column prop="panswerID"     label="父答案编号"></el-table-column>
          <el-table-column prop="answerName"    label="答案选项名称"></el-table-column>
          <el-table-column prop="answerImgPath" label="答案选项图片URL"></el-table-column>
          <el-table-column prop="answerType"    label="答案显示方式">

            <template slot-scope="scope">
              <span v-if="scope.row.answerType == '0'">文字</span>
              <span v-if="scope.row.answerType == '1'">图片</span>
              <span v-if="scope.row.answerType == '2'">叙述</span>
              <span v-if="scope.row.answerType == '3'">填空</span>
            </template>

          </el-table-column>
          <el-table-column prop="answerScore"      label="答案分值(正向)"></el-table-column>
          <el-table-column prop="answerScoreR"     label="答案分值(反向)"></el-table-column>
          <el-table-column prop="ansOptionTypeStr" label="子答案类型"></el-table-column>
          <el-table-column prop="tagging"          label="标签"></el-table-column>
          <el-table-column prop="isActive"         label="是否启用"></el-table-column>
          <el-table-column prop="isActive"         label="是否启用">
            <template slot-scope="scope">
              <span>{{scope.row.isActive == 1?'是':'否'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="lineNumber" label="备注"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="w" @click="xg(scope.row)">修改</span>
              <span class="w" @click="delfun(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="Counts">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import scales from '@/components/scales.vue'
  export default {
    data() {
      return {
        questionName:'',
        formInline: {
          user: '',
          region: ''
        },
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        tableData: [],
        currentPage1:"1",
        Counts:0,
        paperID:''
      };
    },
    components:{
      scales
    },
    
    methods: {
      handleCurrentChange(val) {
        this.xa()
      },
      onSubmit() {
        this.currentPage1 = '1';
        this.xa()
      },
      xg(row){
        this.$router.push({
          path: '/Scale/Add_topic',
          query: { questionID:row.questionID,paperID:row.paperID},
        })
      },
      delfun(row){
        var ji = [row.factorID];
        this.$Http_Post('paperconfig/factor/delete', {factorIDs:ji}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      getmsg(val){//量表点击时子组件传过来值
        this.paperID = val
        this.xa()
      },
      xa(){
          this.$Http_Post('/paperconfig/answercfg/list', {paperCode:this.paperID,pageSize:'10',pageNum:this.currentPage1,questionName:this.questionName}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.tableData = res.Data;
              this.Counts = res.Counts;
            }else{
              this.Global.request_failure(res.Message);
            }
          });
      },
      addfun() {
        this.$router.push({
          path: '/Scale/Add_instruction',
        })
      },
      
      handleNodeClick(data) {

      }
    }
  };
</script>
<style>
.Scale_classification{width: 100%;height: 100%;}
.Scale_classification_nav{width: 100%;height: 100%;}
.Scale_classification_nav_left{width: 450px;height: 100%;overflow: auto;float: left;background-color: #fff;}
.Scale_classification_nav_right{width: calc(100% - 464px);height: 100%;float: right;background-color: #fff;overflow: auto;}
</style>